<template>
	<div class="room-detail">
		<v-layout row wrap mb-3 align-items-center>
			<v-flex md6>
				<media :item="mediaItem"></media>
			</v-flex>
			<v-flex md6>
				<v-layout row wrap justify-end align-items-center>
					<div class="pr-2" v-if="maidRoom.Housekeeping">
						<room-status class="mb-0" v-bind:background-color="room.room_color_state" v-bind:number="room.room"
						  v-bind:code="room.room_state_code" v-bind:status-icon-img="room.icon_url" size="medium"
							v-bind:extra-state="room.extra_state" v-bind:name="room.name">
						</room-status>
					</div>
					<div class="time-container body-border-left mr-3" v-show="maidRoom.Housekeeping">
						<clock v-bind:minute="clockMinute" v-bind:second="clockSecond"
						  v-on:increase-time="increaseTime" />
					</div>
					<div class="body-border-left gauge-container">
						<div class="ml-3">
							<Gauge v-bind:percent="maid.score" />
						</div>
					</div>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap ml-1 mr-1>
			<list-detail-description class="mb-2" :details="mediaItem.details"></list-detail-description>
		</v-layout>
		<table-run v-bind:columns="columns" v-bind:rows="rows" v-bind:selectable="false"
			state-property-name="hot_ms_statehk_id"
		  v-bind:include-delete="false" v-bind:include-export-to-excel="true" v-bind:include-options="true"
		  v-bind:include-state="true" v-bind:include-images="true" v-on:on-search-event="onSearchData"
		  v-on:go-to-photos-page="openRoomPhotos" v-on:on-sortable-event="columnSortableEvent"
		  class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{props.row.code_room}}</td>
				<td>{{props.row.date_clear}}</td>
				<td>{{props.row.type_cleaning_name}}</td>
				<td>{{props.row.duration_standard}}</td>
				<td>{{props.row.duration_time_clear}}</td>
				<td>{{props.row.supervisor_name}} {{props.row.supervisor_lastname}}</td>
			</template>
		</table-run>
	</div>
</template>

<script>

import TableRun from 'table-run';
import { db } from '@/shared/firebase';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import Clock from '@/components/shared/Clock';
import Gauge from '@/components/shared/Gauge';
import ListDetailDescription from '@/components/shared/ListDetailDescription';
import Media from '@/components/shared/Media';
import RoomStatus from '@/components/shared/RoomStatus';

const helperMethods = helper.methods;

function created() {
	const user = helperMethods.getUser();
	this.companyId = user.company_id;
	this.loadData();
}

function columnSortableEvent(id) {
	setTimeout(() => {
		let newData = [];
		const newColumn = this.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		const columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		this.rows = newData;
	}, 300);
}

function increaseTime() {
	if (this.clockSecond === 59) {
		this.clockMinute += 1;
		this.clockSecond = 0;
	} else {
		this.clockSecond += 1;
	}
}

async function loadData(search) {
	try {
		const response = await this.$http.get(`housemaid-detail/${this.id}`, { params: { search } });
		this.maid = response.data;
		this.rows = response.data.rooms;
		this.$bindAsObject('maidRoom', db.ref(`Housemaid/${this.companyId}/${this.id}`));
	} catch (error) {
		this.showNotification('Error interno de servidor, por favor recargue la pagina e intentelo de nuevo', 'error');
	}
}

function onSearchData(value) {
	this.loadData(value);
}

function openRoomPhotos(row) {
	this.$router.push({ name: 'room-photos', params: { roomId: row.id, roomNumber: row.code_room, maidId: this.id } });
}

function mediaItem() {
	const media = {
		avatar: this.maid.url_image,
		title: `${this.maid.name} ${this.maid.lastname}`,
		subtitles: [],
		details: [],
	};
	if (this.maidRoom) {
		if (this.maidRoom.Housekeeping) {
			media.subtitles.push({
				key: 'Estado',
				value: this.maidRoom.Housekeeping.state,
			});
			media.subtitles.push({
				key: 'Habitación',
				value: this.maidRoom.Housekeeping.room,
			});
			media.details.push({
				description: this.maidRoom.Housekeeping.type_cleaning,
				icon: 'type-clean',
				label: 'Tipo de Limpieza',
			});
			media.details.push({
				description: this.maidRoom.Housekeeping.date_start,
				icon: 'date',
				label: 'Fecha',
			});
			media.details.push({
				description: this.maidRoom.Housekeeping.time_standard,
				icon: 'time-standard',
				label: 'Tiempo Standard',
			});
			media.details.push({
				description: this.maidRoom.Housekeeping.time_cleaning,
				icon: 'time-done',
				label: 'Tiempo Realizado',
			});
			media.details.push({
				description: this.maidRoom.Housekeeping.supervisor,
				icon: 'supervisor',
				label: 'Supervisor',
			});
			this.room = this.maidRoom.Housekeeping;
			const clockInfo = this.maidRoom.Housekeeping.time_cleaning.split(':');
			if (clockInfo.length > 0) {
				this.clockMinute = Number(clockInfo[0]);
				this.clockSecond = Number(clockInfo[1]);
			}
		}
	}
	return media;
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
}

export default {
	created,
	name: 'housemaid-profile',
	components: {
		ButtonCreate,
		Clock,
		Gauge,
		ListDetailDescription,
		Media,
		RoomStatus,
		TableRun,
	},
	computed: {
		mediaItem,
	},
	data() {
		return {
			clockMinute: 0,
			clockSecond: 0,
			companyId: 0,
			columns: [
				{ id: 1, name: 'Habitaciones', code: 'name', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Tipo de limpieza', code: 'clean_type', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Tiempo estandar', code: 'time_standard', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Tiempo realizado', code: 'time_done', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Supervisor', code: 'supervisor', isSortable: { down: true, up: false } },
			],
			helperMethods: null,
			maid: {
				url_image: '',
				name: '',
				lastname: '',
				score: 0,
			},
			maidRoom: {
				time_minute: 0,
				time_second: 0,
			},
			rows: [],
			item: {
				avatar: '/static/img/bed-icon.png',
				title: 'María Chiappe',
				subtitles: [
					{
						key: 'Mucama',
						value: 'María Chiappe',
					},
					{
						key: 'Estado',
						value: 'En curso',
					},
				],
			},
			time: '00:45',
			filterValue: 1,
			room: {
				id: 1,
				roomtype_name: '',
				number: '',
				code: '',
				icon: '',
				extra_state: '',
				clean_state: 0,
				time: '00:00',
			},
		};
	},
	methods: {
		columnSortableEvent,
		increaseTime,
		loadData,
		onSearchData,
		openRoomPhotos,
		selectedFilter,
	},
	mixins: mixin,
	props: ['id'],
};
</script>

<style lang="scss" scoped>
.gauge-container {
	align-items: center;
	display: flex;
 	min-height: 47px;
}
.time-container {
	padding-left: 17px;
	width: 165px;
}
</style>



// WEBPACK FOOTER //
// Profile.vue?19680b0b